import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { articleEditPageMatchPath, articleNewMatchPath, articlePageMatchPath } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import Page from '../Page';

import { ContentRoutes } from './ContentRoutes';
import {
  Article,
  ArticleEdit,
  ArticleFooter,
  ArticleNew,
  GroupInsights,
  Logout,
  MediaPostImmersiveView,
} from './loadableComponents';

const Routes: FC = () => {
  const articleWithLeftNav = useExperimentTreatmentWithoutReporting(Experiment.ArticleWithLeftNav) === true;

  return (
    <Switch>
      <Route exact={true} path={articleNewMatchPath}>
        <Page backgroundColor="white" isLeftSidebarEnabled={articleWithLeftNav}>
          <ArticleNew />
        </Page>
      </Route>
      <Route exact={true} path={articleEditPageMatchPath}>
        <Page backgroundColor="white" isLeftSidebarEnabled={articleWithLeftNav}>
          <ArticleEdit />
        </Page>
      </Route>
      <Route exact={true} path={articlePageMatchPath}>
        <Page backgroundColor="white" isLeftSidebarEnabled={articleWithLeftNav} footer={<ArticleFooter />}>
          <Article />
        </Page>
      </Route>
      <Route path="/groups/:groupId/activity">
        <Page>
          <GroupInsights />
        </Page>
      </Route>
      <Route exact={true} path="/media-post/:threadId">
        <MediaPostImmersiveView />
      </Route>
      <Route path="/logout">
        <Page>
          <Logout />
        </Page>
      </Route>
      <Route default={true}>
        <Page>
          <ContentRoutes />
        </Page>
      </Route>
    </Switch>
  );
};

export default Routes;
